/*
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:00
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2024-10-23 09:06:51
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\api\user\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by rubin on 2020/6/6.
 */

'use strict'

import http from '../../utils/http'
import simpleHttp from '../../utils/simple-http'

let userService = {
    login: function (data, resolve, reject) {
        http({
            url: '/memberInfo/memberPinLogin',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    register: function (data, resolve, reject) {
        http({
            url: '/memberInfo/weixinLoginAfter',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    info: function (resolve, reject) {
        http({
            url: '/memberInfo/getMemberInfo',
            data: {},
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    checkwechatNickName: function (data, resolve, reject) {
        http({
            url: '/user/wechatNickName/check',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    checkAnswer: function (data, resolve, reject) {
        http({
            url: '/user/answer/check',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    resetPassword: function (data, resolve, reject) {
        http({
            url: '/user/password/reset',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    changePassword: function (data, resolve, reject) {
        http({
            url: '/user/password/change',
            data: data,
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    exit: function (resolve, reject) {
        http({
            url: '/user/exit',
            method: 'post'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    searchHistories: function (resolve, reject) {
        http({
            url: '/user/search/histories',
            params: {},
            method: 'get'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    checkUserLoginStatus: function (params, resolve, reject) {
        http({
            url: '/user/login/status',
            params: params,
            method: 'get'
        }).then(res => resolve(res)).catch(res => reject(res))
    },
    infoWithoutPageJump(resolve) {
        simpleHttp({
            url: '/memberInfo/getMemberInfo',
            params: {},
            method: 'post'
        }).then(res => resolve(res))
    }
}

export default userService
